import React from "react";
import AddColorForm from "./AddColorForm";

const AddColor = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="col-12">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nuevo Color"}
        </button>
      </div>

      {show && (
        <div className="col-md-8 offset-md-2 mb-3">
          <AddColorForm setShow={setShow} />
        </div>
      )}
    </>
  );
};

export default AddColor;